import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { propTypes } from '../../../util/types';
import ImageLayoutContainer from '../ImageLayoutContainer/ImageLayoutContainer';

import css from './ListingPageImageSection.module.css';

const ListingPageImageSection = props => {
  const { rootClassName, className, images } = props;

  if (!images || images.length === 0) {
    return null;
  }

  const classes = classNames(rootClassName || css.root, className);

  return (
    <section className={classes}>
      <div className={css.container}>
        <ImageLayoutContainer images={images} />
      </div>
    </section>
  );
};

ListingPageImageSection.defaultProps = {
  rootClassName: null,
  className: null,
};

ListingPageImageSection.propTypes = {
  rootClassName: PropTypes.string,
  className: PropTypes.string,
  images: PropTypes.arrayOf(propTypes.image).isRequired,
};

export default ListingPageImageSection;
